(function () {
  if (window.__shufooniMobileFixes) return;
  window.__shufooniMobileFixes = true;

  var menuOpenClass = "shufooni-mobile-menu-open";

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  function addFallbackStyles() {
    if (document.getElementById("shufooni-mobile-fixes-style")) return;

    var style = document.createElement("style");
    style.id = "shufooni-mobile-fixes-style";
    style.textContent = [
      ".shufooni-lazy-fallback{opacity:1!important;visibility:visible!important;}",
      ".sf-image:not([data-image-loading]) img{opacity:1!important;}",
      ".sf-menu-wrapper-mobile.shufooni-menu-visible{display:block!important;}",
      ".sf-menu-wrapper-mobile.shufooni-menu-visible .sf-menu__content{transform:translateX(0)!important;}",
      ".shufooni-mobile-menu-close{position:sticky!important;top:0!important;z-index:3!important;width:100%!important;min-height:52px!important;display:flex!important;align-items:center!important;justify-content:flex-start!important;padding:12px 18px!important;background:#fff!important;border-bottom:1px solid rgba(0,0,0,.08)!important;font-size:30px!important;font-weight:700!important;line-height:1!important;color:#111!important;}",
      ".sf-menu-wrapper-mobile .sf-menu__content .shufooni-mobile-menu-close,.sf-menu-wrapper-mobile .sf-menu__content .shufooni-mobile-menu-close *{color:#111!important;}",
      "html." + menuOpenClass + ",html." + menuOpenClass + " body{overflow:hidden!important;}"
    ].join("\n");
    document.head.appendChild(style);
  }

  function imageWidth() {
    var width = Math.ceil((window.innerWidth || 390) * (window.devicePixelRatio || 2));
    return Math.max(360, Math.min(900, width));
  }

  function hydrateImage(img) {
    if (!img) return;

    var src = img.getAttribute("src");
    var dataSrc = img.getAttribute("data-src");

    if (!src && dataSrc) {
      img.setAttribute("src", dataSrc.replace("_{width}x", "_" + imageWidth() + "x"));
    }

    if (!img.getAttribute("srcset") && img.getAttribute("data-srcset")) {
      img.setAttribute("srcset", img.getAttribute("data-srcset").replace(/\{width\}/g, imageWidth()));
    }

    img.classList.remove("lazyload", "lazyloading");
    img.classList.add("lazyloaded", "shufooni-lazy-fallback");
    img.style.opacity = "1";

    var wrapper = img.closest("[data-image-loading]");
    if (wrapper) wrapper.removeAttribute("data-image-loading");
  }

  function hydrateLazyMedia(root) {
    var scope = root || document;

    scope.querySelectorAll("img[data-src], img.lazyload").forEach(hydrateImage);

    scope.querySelectorAll(".lazyload[data-bg], [data-bg].lazyload").forEach(function (element) {
      var bg = element.getAttribute("data-bg");
      if (!bg) return;
      element.style.backgroundImage = "url(" + bg.replace("_{width}x", "_" + imageWidth() + "x") + ")";
      element.classList.remove("lazyload", "lazyloading");
      element.classList.add("lazyloaded", "shufooni-lazy-fallback");
    });
  }

  function menuNodes() {
    var wrapper = document.querySelector(".sf-menu-wrapper-mobile");
    return {
      wrapper: wrapper,
      panel: wrapper && wrapper.querySelector(".sf-menu__content")
    };
  }

  function ensureCloseButton(panel) {
    if (!panel || panel.querySelector("[data-shufooni-menu-close]")) return;

    var close = document.createElement("button");
    close.type = "button";
    close.className = "shufooni-mobile-menu-close";
    close.setAttribute("data-shufooni-menu-close", "");
    close.setAttribute("aria-label", "סגירת תפריט");
    close.style.setProperty("color", "#111", "important");
    close.innerHTML = '<span aria-hidden="true" style="color:#111!important;display:block;font-size:30px;font-weight:700;line-height:1;">&times;</span>';
    panel.insertBefore(close, panel.firstChild);
  }

  function openMenu(event) {
    if (event) event.preventDefault();
    if (window.innerWidth >= 1024) return;

    var nodes = menuNodes();
    if (!nodes.wrapper) return;

    addFallbackStyles();
    ensureCloseButton(nodes.panel);

    nodes.wrapper.classList.remove("hidden");
    nodes.wrapper.classList.add("shufooni-menu-visible");
    nodes.wrapper.style.setProperty("--tw-bg-opacity", "0.5");
    nodes.wrapper.setAttribute("aria-hidden", "false");

    if (nodes.panel) {
      nodes.panel.classList.remove("-translate-x-full", "translate-x-full");
      nodes.panel.classList.add("translate-x-0");
      nodes.panel.style.transform = "translateX(0)";
    }

    document.documentElement.classList.add(menuOpenClass, "prevent-scroll");
  }

  function closeMenu(event) {
    if (event) event.preventDefault();

    var nodes = menuNodes();
    if (!nodes.wrapper) return;

    nodes.wrapper.style.setProperty("--tw-bg-opacity", "0");

    if (nodes.panel) {
      nodes.panel.classList.add("-translate-x-full");
      nodes.panel.classList.remove("translate-x-0");
      nodes.panel.style.removeProperty("transform");
    }

    window.setTimeout(function () {
      nodes.wrapper.classList.add("hidden");
      nodes.wrapper.classList.remove("shufooni-menu-visible");
      nodes.wrapper.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove(menuOpenClass, "prevent-scroll");
    }, 250);
  }

  function initMobileMenuFallback() {
    document.addEventListener(
      "click",
      function (event) {
        var trigger = event.target.closest && event.target.closest(".sf-menu-button");
        if (trigger) {
          openMenu(event);
          return;
        }

        var close = event.target.closest && event.target.closest("[data-shufooni-menu-close]");
        if (close) {
          closeMenu(event);
          return;
        }

        var nodes = menuNodes();
        if (nodes.wrapper && event.target === nodes.wrapper) closeMenu(event);
      },
      true
    );

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeMenu(event);
    });
  }

  function initCartUpsellAdds() {
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest && event.target.closest("[data-shufooni-upsell-add]");
      if (!trigger || trigger.classList.contains("is-loading")) return;

      event.preventDefault();

      var variantId = trigger.getAttribute("data-variant-id");
      var card = trigger.closest("[data-shufooni-upsell-card]");
      var label = trigger.querySelector("span") || trigger;
      var originalText = label.textContent;

      if (!variantId) {
        window.location.href = trigger.href;
        return;
      }

      trigger.classList.add("is-loading");
      label.textContent = "מוסיף...";

      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties: {
            "_source": "cart_upsell_20"
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw response;
          return response.json();
        })
        .then(function (item) {
          label.textContent = "נוסף";
          trigger.classList.remove("is-loading");
          trigger.setAttribute("aria-disabled", "true");

          if (/\/cart\/?$/.test(window.location.pathname)) {
            window.location.reload();
            return;
          }

          if (card) {
            card.classList.add("is-added");
            window.setTimeout(function () {
              card.remove();
              document.querySelectorAll(".shufooni-cart-upsell").forEach(function (wrapper) {
                if (!wrapper.querySelector("[data-shufooni-upsell-card]")) wrapper.remove();
              });
            }, 700);
          }

          if (window.Shopify && typeof window.Shopify.onItemAdded === "function") {
            item.source = "shufooni-cart-upsell";
            window.Shopify.onItemAdded(item);
            return;
          }

          fetch("/cart.js", { credentials: "same-origin" })
            .then(function (cartResponse) { return cartResponse.json(); })
            .then(function (cart) {
              if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") {
                window.Shopify.onCartUpdate(cart);
              }
            })
            .catch(function () {});
        })
        .catch(function () {
          trigger.classList.remove("is-loading");
          label.textContent = originalText || "הוסף";
          window.location.href = trigger.href;
      });
    });
  }

  var cartFallbackBusy = false;

  function cartRequestConfig(body) {
    return {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(body)
    };
  }

  function isCartPage() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function cartSectionId() {
    return isCartPage() ? "cart-template" : "cart-drawer";
  }

  function cartSectionUrl() {
    var root = "/";
    if (window.spratlyThemeSettings && window.spratlyThemeSettings.routes && window.spratlyThemeSettings.routes.root) {
      root = window.spratlyThemeSettings.routes.root;
    }
    return root + "?section_id=" + cartSectionId();
  }

  function activeCartWrapper() {
    return document.querySelector(".scd__wrapper:not(.hidden)") ||
      document.querySelector("[data-cart-wrapper]") ||
      document.querySelector(".scd__wrapper");
  }

  function isNativeCartUpdating(wrapper) {
    if (!wrapper) return false;
    var content = wrapper.querySelector(".scd__content") || wrapper;
    return content.classList.contains("loading") ||
      content.classList.contains("al-loading-bar") ||
      content.classList.contains("overlay-show");
  }

  function updateCartBadges(cart) {
    if (!cart || typeof cart.item_count === "undefined") return;

    document.body.classList.toggle("cart-empty", Number(cart.item_count) < 1);
    document.querySelectorAll(".sf-cart-count").forEach(function (count) {
      count.textContent = cart.item_count;
    });
  }

  function replaceCartPart(wrapper, source, selector) {
    var current = wrapper && wrapper.querySelector(selector);
    var fresh = source && source.querySelector(selector);

    if (current && fresh) {
      current.replaceWith(fresh);
      return true;
    }

    if (current && selector === ".scd__summary") {
      current.style.display = "none";
    }

    return false;
  }

  function refreshCartMarkup(cart) {
    return fetch(cartSectionUrl(), {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var container = document.createElement("div");
        container.innerHTML = html;

        var wrapper = activeCartWrapper();
        if (wrapper) {
          replaceCartPart(wrapper, container, ".scd__body");
          replaceCartPart(wrapper, container, ".scd__summary");
        }

        updateCartBadges(cart);

        if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") {
          try {
            window.Shopify.onCartUpdate(cart, false);
          } catch (error) {}
        }
      });
  }

  function changeCartItemFallback(id, quantity, wrapper) {
    quantity = Number(quantity);
    if (!id || Number.isNaN(quantity)) return;

    cartFallbackBusy = true;
    if (wrapper) wrapper.classList.add("shufooni-cart-fallback-loading");

    fetch("/cart/change.js", cartRequestConfig({
      id: id,
      quantity: Math.max(0, quantity)
    }))
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(refreshCartMarkup)
      .catch(function (error) {
        console.warn("Shufooni cart control fallback failed", error);
      })
      .finally(function () {
        cartFallbackBusy = false;
        if (wrapper) wrapper.classList.remove("shufooni-cart-fallback-loading");
      });
  }

  function scheduleCartControlFallback(control, quantity) {
    if (cartFallbackBusy || !control) return;

    var item = control.closest && control.closest("[data-cart-item]");
    var wrapper = control.closest && control.closest(".scd__wrapper, .sf-cart");
    var id = control.getAttribute("data-id") || (item && item.getAttribute("data-id"));
    var input = item && item.querySelector(".scd-item__qty_input");
    var startingValue = input && input.value;

    if (!item || !wrapper || !id) return;

    window.setTimeout(function () {
      if (!document.documentElement.contains(item)) return;
      if (isNativeCartUpdating(wrapper)) return;

      var currentInput = item.querySelector(".scd-item__qty_input");
      if (currentInput && startingValue !== null && currentInput.value !== startingValue && control.tagName !== "INPUT") return;

      changeCartItemFallback(id, quantity, wrapper);
    }, 140);
  }

  function initCartControlFallback() {
    document.addEventListener("click", function (event) {
      var remove = event.target.closest && event.target.closest(".scd-item__remove");
      var qtyButton = event.target.closest && event.target.closest(".scd-item__btn");
      var control = remove || qtyButton;
      if (!control) return;

      event.preventDefault();

      var item = control.closest("[data-cart-item]");
      if (!item) return;

      var input = item.querySelector(".scd-item__qty_input");
      var currentQuantity = Number(input && input.value);
      var nextQuantity = 0;

      if (qtyButton && !remove) {
        nextQuantity = currentQuantity + (qtyButton.getAttribute("data-qty-change") === "dec" ? -1 : 1);
      }

      scheduleCartControlFallback(control, nextQuantity);
    });

    document.addEventListener("change", function (event) {
      var input = event.target.closest && event.target.closest(".scd-item__qty_input");
      if (!input) return;

      scheduleCartControlFallback(input, Number(input.value));
    });
  }

  ready(function () {
    addFallbackStyles();
    hydrateLazyMedia(document);
    initMobileMenuFallback();
    initCartUpsellAdds();
    initCartControlFallback();

    window.setTimeout(function () {
      hydrateLazyMedia(document);
    }, 700);

    window.addEventListener("load", function () {
      hydrateLazyMedia(document);
    });
  });
})();
